/* THIS FILE IS AUTO-GENERATED! DO NOT MODIFY!! */
/* eslint-disable */
// @ts-nocheck

import type * as Types from '@/graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { WorkspaceModelFragmentDoc, WorkspaceCurrentModelDeploymentStatusFragmentDoc, WorkspaceModelVersionCountByStatusFragmentDoc } from '../../../../sections/Overview/Models/__generated__/fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WorkspaceModelsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type WorkspaceModelsQuery = { __typename?: 'QueryPrediction', models: Array<{ __typename?: 'ModelType', id: string, name: string | null | undefined, modified: any, created: any, lastActivity: string | null | undefined, primaryVersion: { __typename?: 'ModelVersionType', id: string, isPrimary: boolean, currentModelDeploymentStatus: { __typename?: 'ModelDeploymentStatusType', id: string, status: Types.DeploymentStatus | null | undefined } | null | undefined } | null | undefined, versionCountByStatus: Array<{ __typename?: 'ModelVersionByStatusCount', status: Types.DeploymentStatus | null | undefined, count: number | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };


export const WorkspaceModelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceModels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"models"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkspaceModelFragment"}}]}}]}},...WorkspaceModelFragmentDoc.definitions,...WorkspaceCurrentModelDeploymentStatusFragmentDoc.definitions,...WorkspaceModelVersionCountByStatusFragmentDoc.definitions]} as unknown as DocumentNode<WorkspaceModelsQuery, WorkspaceModelsQueryVariables>;
export const namedOperations = {
  Query: {
    WorkspaceModels: 'WorkspaceModels'
  }
}

/**
 * __useWorkspaceModelsQuery__
 *
 * To run a query within a React component, call `useWorkspaceModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceModelsQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceModelsQuery, WorkspaceModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceModelsQuery, WorkspaceModelsQueryVariables>(WorkspaceModelsDocument, options);
      }
export function useWorkspaceModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceModelsQuery, WorkspaceModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceModelsQuery, WorkspaceModelsQueryVariables>(WorkspaceModelsDocument, options);
        }
export type WorkspaceModelsQueryHookResult = ReturnType<typeof useWorkspaceModelsQuery>;
export type WorkspaceModelsLazyQueryHookResult = ReturnType<typeof useWorkspaceModelsLazyQuery>;
export type WorkspaceModelsQueryResult = Apollo.QueryResult<WorkspaceModelsQuery, WorkspaceModelsQueryVariables>;
export function refetchWorkspaceModelsQuery(variables?: WorkspaceModelsQueryVariables) {
      return { query: WorkspaceModelsDocument, variables: variables }
    }